import {NgModule, ModuleWithProviders} from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { API_CONFIG } from './api.config';
import {ApiService, ApiServiceConfig} from "./api.service";

export function ApiServiceFactory(http: HttpClient, apiConfig: ApiServiceConfig) {
  return new ApiService(http, apiConfig);
}

@NgModule({ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ApiModule {
  // @ts-ignore
  static forRoot(apiConfig: ApiServiceConfig = {}): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiService,
          useFactory: ApiServiceFactory,
          deps: [HttpClient, API_CONFIG]
        },
        {
          provide:  API_CONFIG,
          useValue: apiConfig
        }
      ]
    };
  }
}
